import { render } from "./PoweredBy.vue?vue&type=template&id=5bf0ca17"
import script from "./PoweredBy.vue?vue&type=script&lang=ts"
export * from "./PoweredBy.vue?vue&type=script&lang=ts"

import "./PoweredBy.vue?vue&type=style&index=0&id=5bf0ca17&lang=scss"
script.render = render

export default script